import LogoImg from "../images/LogoImg";
import { Link, useLocation } from "react-router-dom";
import MainMenu from "../components/Menu/MainMenu";
import { useAuth } from "../supabase/AuthProvider";
import CourseIcon from "../images/CourseIcon";
import { Typography } from "../components/common";
import { MobileMenu } from "../components/Menu/index";
import { useGetCurrentUserQuery } from "../store/api/postgresUserApi";

import { AppHomeButton } from "@pedagogue/ui-core";

// WordPress marketing site URL
const MARKETING_SITE_URL = process.env.REACT_APP_MARKETING_SITE_URL || "https://pedagogue.io";
const getAppHomeUrl = () => process.env.REACT_APP_APP_HOME_URL || "https://app.pedagogue.io";

function Navbar() {
  const { user } = useAuth();
  const location = useLocation();

  // Fetch current user data from REST API only if user is logged in
  const { data: currentUser } =
    useGetCurrentUserQuery(undefined, {
      skip: !user, // Skip the query if user is not logged in
    });

  // Navigation links for authenticated users
  // Note: / route redirects to WordPress for unauthenticated users, so we use /courses as home
  const NAV_LINKS = [
    { to: "/courses", label: "Courses", Icon: CourseIcon },
  ];

  const currentPath = location.pathname;

  return (
    <header className="bg-white flex items-center justify-between py-6 px-4 md:px-8 lg:px-16 h-[88px] sticky top-0 z-[10000]">
      <div className="flex items-center gap-3">
        {user ? (
          <a href={getAppHomeUrl()} className="block">
            <LogoImg className="cursor-pointer" />
          </a>
        ) : (
          <a href={MARKETING_SITE_URL} className="block">
            <LogoImg className="cursor-pointer" />
          </a>
        )}
        {/* App Home: always-visible launchpad-return control for authenticated
            users (APP_LAUNCHPAD_UX_SPEC §7.1 — left-aligned, all viewports; NOT
            in the desktop-only `hidden lg:flex` nav below). */}
        {user && (
          <AppHomeButton
            url={getAppHomeUrl()}
            className="rounded-lg hover:bg-gray-100 transition-colors"
          />
        )}
      </div>

      {/* Desktop Navigation */}
      <nav className="items-center hidden gap-10 lg:flex">
        {NAV_LINKS.map(({ to, label, Icon }) => (
          <Link key={to} to={to} className="flex items-center gap-2">
            {Icon && (
              <Icon
                height="20"
                width="20"
                fill={currentPath === to ? undefined : ""}
              />
            )}
            <Typography
              variant="p"
              className="text-red-500"
              weight={`${currentPath === to ? "bold" : "normal"}`}
            >
              {label}
            </Typography>
          </Link>
        ))}
      </nav>

      <div className="flex items-center gap-2 sm:gap-4 md:gap-6">
        {/* Mobile Menu */}
        <MobileMenu navLinks={NAV_LINKS} currentUser={currentUser} />

        {/* User Menu - Hidden on mobile, shown in hamburger menu */}
        <div className="hidden lg:block">
          <MainMenu currentUser={currentUser} />
        </div>
      </div>
    </header>
  );
}

export default Navbar;
